import React from 'react';
// import PropTypes from 'prop-types';

import cn from 'classnames';

function useAnimateOnMount() {
  const [animate, setAnimate] = React.useState(false);

  React.useEffect(() => {
    setAnimate(true);

    return () => setAnimate(false);
  }, []);

  return cn('!transition-colors !ease !duration-1000', {
    '!bg-yellow-100 !bg-opacity-50': !animate,
  });
}

export default useAnimateOnMount;

useAnimateOnMount.defaultProps = {};

useAnimateOnMount.propTypes = {};
